import { makeAutoObservable } from 'mobx';
import { HttpStore } from '@monorepo/controlled/src/stores/http.store';
import { IInventoryListResponse, IInventoryRequestParams, InventoryApi } from '../../apis/inventory.api';
import { InventoryModel } from '../../models/inventory.model';
import { SettingsStore } from '@monorepo/controlled/src/stores/settings.store';
import { FilterStore } from '@monorepo/controlled/src/stores/filter.store';
import { TableStore } from '@monorepo/controlled/src/stores/table.store';
import { filterPrototypesByProp } from '../../components/filters';
import { Row } from '@tanstack/react-table';
import { INVENTORY_DEFAULT_SORT } from './inventory.constants';

export enum InventoryStoreFiltersKeys {
	Inventory = 'inventory',
}

export class InventoryStore {
	list = new HttpStore<IInventoryRequestParams, IInventoryListResponse>({
		httpFunc: InventoryApi.list,
	});

	sortedRows: Row<InventoryModel>[] = [];
	page = 1;
	pageSize = 1000;
	total = 0;
	hasMore = false;
	lastFetchedAt = 0;

	settingsStore: SettingsStore;

	constructor(settingsStore: SettingsStore) {
		makeAutoObservable(this);
		this.settingsStore = settingsStore;
		this.createDefaultFilters();
	}

	createDefaultFilters() {
		Object.values(InventoryStoreFiltersKeys).map((key: InventoryStoreFiltersKeys) => {
			if (!this.settingsStore.getPages().get(key)) {
				const tableStore = new TableStore();
				tableStore.setSortingBy(INVENTORY_DEFAULT_SORT);
				this.settingsStore.getPages().set(key, { tableStore });
			} else {
				const existingTable = this.settingsStore.getPages().get(key)?.tableStore;
				if (existingTable && (existingTable.getSortingBy() ?? []).length === 0) {
					existingTable.setSortingBy(INVENTORY_DEFAULT_SORT);
				}
			}
			const publishersFilterByKey = new FilterStore({
				key,
				currentFilters: undefined,
				filterPrototypesByProp,
			});
			this.settingsStore.getPages().get(key)?.tableStore.setFiltersStore(key, publishersFilterByKey);
		});
	}

	getListStore() {
		return this.list;
	}

	setPage(page: number): void {
		this.page = page;
	}

	setPaginationMeta(total: number, page: number, pageSize: number, hasMore: boolean): void {
		this.total = total;
		this.page = page;
		this.pageSize = pageSize;
		this.hasMore = hasMore;
	}

	getSortedRows(): Row<InventoryModel>[] {
		return this.sortedRows;
	}

	setSortedRows(sortedRows: Row<InventoryModel>[]): void {
		this.sortedRows = sortedRows;
	}

	setLastFetchedAt(ts: number): void {
		this.lastFetchedAt = ts;
	}
}
